<template>
  <span>
    <a-button size="small" type="primary" icon="check" @click.prevent="showModal">
      {{ $t('Ingresar Actividad') }}
    </a-button>

    <a-modal
      :title="$t('Crear Actividad')"
      :visible="modalVisible"
      @ok="confirmar"
      :confirmLoading="modalLoading"
      @cancel="cancelar"
      destroyOnClose
      width="80%"
    >
      <a-form :form="form" @submit.prevent="confirmar">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
              <g-dropdown
                :label="$t('Placa-Proyecto')"
                endpoint="hierarchy_lookup"
                :params="placaProyectoParams"
                placeholder="Seleccione vehículo o proyecto"
                :formItemConfig="fiOptions"
                :decorator="['license_plate_or_project', { rules: [{ required: true, message: 'Valor requerido' }] }]"
              />
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Fecha de Servicio')" v-bind="fiOptions">
              <a-date-picker
                style="width: 100%"
                valueFormat="YYYY-MM-DD"
                v-decorator="['service_date', {
                    initialValue: fechaServicioInicial,
                    rules: [{ required: false, message: 'Valor requerido' }]
                  }]"
              />
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Lugar de Salida')" v-bind="fiOptions">
              <a-input
                style="width: 100%"
                placeholder="Ejemplo: Calle 123, Ciudad"
                v-decorator="['place_of_departure', { rules: [{ required: false, message: 'Valor requerido' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Hora Inicial del Servicio')" v-bind="fiOptions">
              <a-time-picker
                style="width: 100%"
                format="HH:mm"
                valueFormat="HH:mm"
                v-decorator="['start_time', { rules: [{ required: false, message: 'Valor requerido' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Kilometraje Inicial')" v-bind="fiOptions">
              <a-input-number
                style="width: 100%"
                :min="0"
                :parser="digitsOnly"
                v-decorator="['initial_mileage', { rules: [{ required: false, message: 'Valor requerido' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Descripción Primer Recorrido')" v-bind="fiOptions">
              <a-textarea
                style="width: 100%"
                autoSize
                placeholder="Origen - Destino"
                v-decorator="['description_route', { rules: [{ required: false, message: 'Valor requerido' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('¿Realiza otro recorrido?. Si es asi, indique cual')"
                         v-bind="fiOptions">
              <a-textarea
                style="width: 100%"
                autoSize
                placeholder="Si, ¿cuál?"
                v-decorator="['make_another_tour', { rules: [{ required: false, message: 'Valor requerido' }] }]"
              />
            </a-form-item>
          </a-col>

          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Hora Final del servicio')" v-bind="fiOptions">
              <a-time-picker
                style="width: 100%"
                format="HH:mm"
                valueFormat="HH:mm"
                v-decorator="['end_time', { rules: [{ required: false, message: 'Valor requerido' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Kilometraje Final')" v-bind="fiOptions">
              <a-input-number
                style="width: 100%"
                :min="0"
                :parser="digitsOnly"
                v-decorator="['final_mileage',{ rules: [{ required: false, message: 'Valor requerido' }] }]"
              />
            </a-form-item>
          </a-col>

          <a-col v-bind="colOptions">
              <g-dropdown
                :label="$t('Nombre Cliente')"
                endpoint="hierarchy_lookup"
                :params="clienteParams"
                placeholder="Seleccione cliente"
                :formItemConfig="fiOptions"
                :decorator="['client_name', { rules: [{ required: false, message: 'Valor requerido' }] }]"
              />
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Cantidad de Pasajeros Transportados')" v-bind="fiOptions">
              <a-input-number
                style="width: 100%"
                :min="0"
                :max="3"
                v-decorator="['number_passengers', { rules: [{ required: false, message: 'Valor requerido' }] }]"
              />
            </a-form-item>
          </a-col>

          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Hora de descanso')" v-bind="fiOptions">
              <a-time-picker style="width: 100%" format="HH:mm" valueFormat="HH:mm" v-decorator="['break_time']"/>

            </a-form-item>
            <small style="margin-top: -100px">{{ $t('Máximo una hora') }}</small>
          </a-col>
        </a-row>
        <a-alert type="error" :message="mensajeError" v-if="error"/>
      </a-form>
    </a-modal>
  </span>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import moment from 'moment'

  export default {
    data () {
      return {
        modalVisible: false,
        modalLoading: true,
        mensajeError: '',
        error: false,
        fechaServicioInicial: moment().format('YYYY-MM-DD'),
        form: this.$form.createForm(this, {name: 'solicitar'}),
        fiOptions: {
          'label-col': {},
          'wrapper-col': {span: 24},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 8},
        placaProyectoParams: {h_lookup_type: 'PLACA_PROYECTO_GEO_MAR'},
        clienteParams: {h_lookup_type: 'CLIENTE_GEO_MAR'},
        actividadesData: {}
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      digitsOnly (value) {
        const s = value == null ? '' : String(value)
        return s.replace(/\D/g, '')
      },
      cancelar () {
        if (this.modalLoading) return
        this.modalVisible = false
        this.error = false
        this.mensajeError = ''
      },
      confirmar () {
        this.form.validateFields((err, values) => {
          if (!err) {
            this.httpClient.getInstance().post('ss/dashboard/actividades_geo', values)
              .then((response) => {
                this.error = false
                this.mensajeError = ''
                this.modalVisible = false
                Mensajes.success('Correcto', response.data.message)
                this.form.resetFields()
                this.$emit('success', {})
              })
              .catch(() => {
                Mensajes.error('Error', 'No fue posible cargar las marcaciones, contacte a mesa de ayuda.')
              })
              .finally(() => {
                this.modalLoading = false
              })
          }
        })
      },
      showModal () {
        this.modalVisible = true
        this.modalLoading = false
        this.error = false
        this.mensajeError = ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/SelfService/pages/Dashboard/BotonMisActividadesGeo.vue